import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import cursorImg from '../assets/cursor.png';

const Cursor = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const mouseMove = (e) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY
      });
    };

    window.addEventListener("mousemove", mouseMove);

    return () => {
      window.removeEventListener("mousemove", mouseMove);
    };
  }, []);

  return (
    <motion.div
      className="app-cursor" // Added class for responsive hiding
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: 48, // Adjusted size per request
        height: 48,
        pointerEvents: 'none',
        zIndex: 99999,
        // Removed mixBlendMode as it might be causing visibility issues
        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
      }}
      animate={{
        x: mousePosition.x - 24, // Center of 48px is 24
        y: mousePosition.y - 24,
      }}
      transition={{
        type: "tween",
        ease: "linear",
        duration: 0
      }}
    >
      <img 
        src={cursorImg} 
        alt="Custom Cursor" 
        style={{ 
          width: '100%', 
          height: '100%', 
          display: 'block' 
        }} 
      />
    </motion.div>
  );
};

export default Cursor;
